// extracted by mini-css-extract-plugin
module.exports = {"card":"TransactionCard_card__AdhmE","line":"TransactionCard_line__32Kbx","label":"TransactionCard_label__1q92Z","value":"TransactionCard_value__2e1-w"};